// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Search20 from './Search20.tsx';
import Search20Circle from './Search20Circle.tsx';
import Search24 from './Search24.tsx';
import Search24Circle from './Search24Circle.tsx';
import Search40 from './Search40.tsx';
import Search48 from './Search48.tsx';

type SearchProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Search20,
    Search20Circle,
    Search24,
    Search24Circle,
    Search40,
    Search48,
};

const Search: FC<SearchProps> = ({ variation, ...props }) => {
    const variationKey = `Search${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Search" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Search;
